<slot-manager
    *ngFor="let slice of element.children; let i = index"
    class="slice-stacked"
    [class.first-slot]="i === 0"
    [style.--overlay]="i * 10"
    [element]="slice"
    [direction]="direction"
    [resolution]="resolution"
    [hasLogoSections]="hasLogoSections"
></slot-manager>
